import { setRequestHeadersForAuth2, generateFormBody, getTokenFromMobile } from './helpers';
import { fetchConfig } from '../util/fetchConfig';
import { APP_ID_BUSINESS_BANKING } from '../util/Constants';

export const fetchJWT = async () => {
  try {
    const config = await fetchConfig();
    const shorttermToken = await fetchShortTermToken(config);
    const jwtToken = await fetchExchangeToken(config, shorttermToken);
    return jwtToken;
  } catch (error) {
    return error;
  }
};

export const fetchShortTermToken = async (config) => {
  const path = `banks/${window.urlParams.bankId}/auth/provider/oauth2/token/shortterm`;

  const url = `${config.apiBaseUrlPaas}/${path}`;
  const accessToken =
    window.urlParams.appId === APP_ID_BUSINESS_BANKING
      ? getTokenFromMobile()
      : window.urlParams.accessTokenFromClient;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: setRequestHeadersForAuth2(accessToken),
      body: generateFormBody()
    });
    const responseJson = await response.json();
    const shortTermAccessToken = await responseJson['access_token'];
    return shortTermAccessToken;
  } catch (error) {
    return error;
  }
};

export const fetchExchangeToken = async (config, accessTokenFromShortTerm) => {
  const path = `banks/${window.urlParams.bankId}/auth/provider/oauth2/token/exchange/jwt`;
  const url = `${config.apiBaseUrlPaas}/${path}`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: setRequestHeadersForAuth2(accessTokenFromShortTerm),
      body: generateFormBody()
    });
    const jwt = await response.text();
    return jwt;
  } catch (error) {
    return error;
  }
};
